export default __webpack_public_path__ + "bg221945a.png";